var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvatarDefault(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 40,
    viewBox: "0 0 28 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4956 10.1644C22.4956 15.9968 18.6629 22.1626 13.9968 22.1626C9.33084 22.1626 5.49805 16.1635 5.49805 10.1644C5.49805 4.16525 9.33084 0.665771 13.9968 0.665771C18.6629 0.665771 22.4956 4.3319 22.4956 10.1644Z",
    fill: "#DDAB6F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4956 10.1644C22.4956 15.9968 18.6629 22.1626 13.9968 22.1626C9.33084 22.1626 5.49805 16.1635 5.49805 10.1644C5.49805 4.16525 9.33084 0.665771 13.9968 0.665771C18.6629 0.665771 22.4956 4.3319 22.4956 10.1644Z",
    fill: "#DDAB6F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4957 23.4958H18.8294C17.9962 25.3289 16.1631 26.4954 13.9968 26.4954C11.8304 26.4954 9.99733 25.3289 9.16412 23.4958H6.49783C3.16496 23.4958 0.332031 26.3288 0.332031 29.6616V33.4944C3.83154 36.8272 8.66419 38.8269 13.9968 38.9936C19.3293 39.1602 23.9954 37.1605 27.6615 33.661V29.6616C27.6615 26.3288 24.8286 23.4958 21.4957 23.4958Z",
    fill: "#C4C4C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarDefault);
export default __webpack_public_path__ + "static/media/avatar-default.08b197f3d8c8ad0b9fe6628ed202b0dd.svg";
export { ForwardRef as ReactComponent };